import { render, staticRenderFns } from "./verificationDetails.vue?vue&type=template&id=3480d7bc"
import script from "./verificationDetails.vue?vue&type=script&lang=js"
export * from "./verificationDetails.vue?vue&type=script&lang=js"
import style0 from "./verificationDetails.vue?vue&type=style&index=0&id=3480d7bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports